import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full-layout/loadable/Loadable';
import PrivateRouteFrn from './PrivateRouteFrn';
import PrivateRouteEmployee from './PrivateRouteEmpl';
import TacheListContainer from '../features/tache/TacheListe.container';
import CDStockTmpAlertContainer from '../features/catalogue-diamant/CDStockTmpAlert.container';
import InventaireDiamantDetailsContainer from '../features/stock-diamant/InventaireDiamantDetails.container';
import InventaireDiamantListContainer from '../features/stock-diamant/InventaireDiamantList.container';
import CmdExpeditionListContainer from '../features/commande-fournisseur/CmdExpeditionListe.container';
import CmdBulkEditContainer from '../features/commande-fournisseur/CmdBulkEdit.container';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full-layout/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank-layout/BlankLayout')));
/* ***End Layouts**** */

const Error = Loadable(lazy(() => import('../views/authentication/Error')));

/* ****Pages***** */

/* *************************Common*********************************************************************/
const Login = Loadable(lazy(() => import('../features/auth/login.container')));
const PrivateRoute = Loadable(lazy(() => import('./PrivateRoute')));

/* *************************Admin*********************************************************************/

const TacheAdmReview = Loadable(lazy(() => import('../features/tache/TacheAdmReview.container')));
const Users = Loadable(lazy(() => import('../features/users/users.container')));
const Clients = Loadable(lazy(() => import('../features/clients/admin/clients.container')));
const Fournisseurs = Loadable(lazy(() => import('../features/fournisseur/fournisseurs.container')));
const GroupeMagasins = Loadable(
  lazy(() => import('../features/groupe-magasins/groupe-magasins.container')),
);
const Magasins = Loadable(lazy(() => import('../features/magasin/magasins.container')));
const SecurityRule = Loadable(lazy(() => import('../features/security/UserAccess.container')));
const SecurityDataAccess = Loadable(
  lazy(() => import('../features/security/DataAccess.container')),
);
const Catalogues = Loadable(
  lazy(() => import('../features/catalogue/admin/CatalogueManager.container')),
);
const CatalogueSettings = Loadable(
  lazy(() => import('../features/catalogue/admin/CatalogueSettingManager')),
);
const MetauxCoursManager = Loadable(
  lazy(() => import('../features/catalogue/admin/MetauxCoursManager.container')),
);
const CatalogueDiamants = Loadable(
  lazy(() => import('../features/catalogue-diamant/CatalogueDiamantManager.container')),
);
const CmdFournisseurCEF = Loadable(
  lazy(() => import('../features/commande-fournisseur/CmdFournisseurCEF.container')),
);
const CmdFournisseurList = Loadable(
  lazy(() => import('../features/commande-fournisseur/CmdFournisseurList.container')),
);
const CmdFournisseurAlerts = Loadable(
  lazy(() => import('../features/commande-fournisseur/CmdFournisseurAlerts.container')),
);
const CmdFournisseurArrivage = Loadable(
  lazy(() => import('../features/commande-fournisseur/CmdFournisseurArrivage')),
);
const ArrivageFbDetails = Loadable(
  lazy(() => import('../features/commande-fournisseur/ArrivageFbDetails.container')),
);
const CmdFournisseurRevoirArrivage = Loadable(
  lazy(() => import('../features/commande-fournisseur/CmdFournisseurRevoirArrivage')),
);
const CmdArchiveList = Loadable(
  lazy(() => import('../features/commande-fournisseur/CmdArchiveList.container')),
);

const StockDiamantManager = Loadable(
  lazy(() => import('../features/stock-diamant/StockDiamantManager.container')),
);
const StockDiamantInventaire = Loadable(
  lazy(() => import('../features/stock-diamant/StockDiamantInventaire.container')),
);
const DocumentDiamantFBCEF = Loadable(
  lazy(() => import('../features/stock-diamant/DocumentDiamantFBCEF.container.')),
);
const RetourDiamantFBCEF = Loadable(
  lazy(() => import('../features/stock-diamant/RetourDiamantFBCEF.container')),
);
const SortieDiamantFBCEF = Loadable(
  lazy(() => import('../features/stock-diamant/SortieDiamantFBCEF.container')),
);
const DocumentDiamantFBList = Loadable(
  lazy(() => import('../features/stock-diamant/DocumentDiamantFBList.container')),
);
const DocumentDiamantFBDetails = Loadable(
  lazy(() => import('../features/stock-diamant/DocumentDiamantFBDetails.container')),
);
const SaisieStockDiamantForce = Loadable(
  lazy(() => import('../features/stock-diamant/SaisieStockDiamantForce.container')),
);

const MvmStockDiaFbCEF = Loadable(
  lazy(() => import('../features/stock-diamant-fb/admin/MvmStockDiaFbCEF.container')),
);
const MvmStockDiaFbList = Loadable(
  lazy(() => import('../features/stock-diamant-fb/admin/MvmStockDiaFbList.container')),
);
const MvmStockDiaFbDetails = Loadable(
  lazy(() => import('../features/stock-diamant-fb/admin/MvmStockDiaFbDetails.container')),
);
const StockDiamantFbList = Loadable(
  lazy(() => import('../features/stock-diamant-fb/admin/StockDiamantFbList.container')),
);
const RetourStockDiaFbCEF = Loadable(
  lazy(() => import('../features/stock-diamant-fb/admin/RetourStockDiaFbCEF.container')),
);

const DmdReassortList = Loadable(
  lazy(() => import('../features/reassort/DmdReassortList.container')),
);

const CaisseMenu = Loadable(lazy(() => import('../features/caisse/admin/CaisseMenu.container')));
const DocClientForm = Loadable(
  lazy(() => import('../features/caisse/admin/DocClientForm.container')),
);
const DocClientDetails = Loadable(
  lazy(() => import('../features/caisse/admin/DocClientDetails.container')),
);
const DocClientList = Loadable(
  lazy(() => import('../features/caisse/admin/DocClientList.container')),
);
const AcompteClientList = Loadable(
  lazy(() => import('../features/caisse/admin/AcompteClientList.container')),
);
const DevisClientList = Loadable(
  lazy(() => import('../features/caisse/admin/DevisClientList.container')),
);

const ReparationForm = Loadable(
  lazy(() => import('../features/reparation/admin/ReparationForm.container')),
);
const ReparationList = Loadable(
  lazy(() => import('../features/reparation/admin/ReparationList.container')),
);
const ReparationDetails = Loadable(
  lazy(() => import('../features/reparation/admin/ReparationDetails.container')),
);
const StripeClientList = Loadable(
  lazy(() => import('../features/caisse/admin/StripeClientList.container')),
);
const AlmaClientList = Loadable(
  lazy(() => import('../features/caisse/admin/AlmaClientList.container')),
);

const AdminCalendar = Loadable(lazy(() => import('../features/rdv/admin/AdminCalendar.container')));

const VentePrivee = Loadable(lazy(() => import('../features/vente-privee/VentePriveeContainer')));
const ProspectList = Loadable(lazy(() => import('../features/vente-privee/ProspectListContainer')));
const VpCalendar = Loadable(lazy(() => import('../features/vente-privee/VpCalendar')));
const VpCompagneSource = Loadable(
  lazy(() => import('../features/vente-privee/CompagneSourceContainer')),
);
const VpProspectScannerContainer = Loadable(
  lazy(() => import('../features/vente-privee/VpProspectScanner.container')),
);
const WhatsAppContainer = Loadable(lazy(() => import('../features/whatsup/WhatsAppContainer')));

/* *************************Employee*****************************************************************/

const CataloguesEmpl = Loadable(
  lazy(() => import('../features/catalogue/employe/CatalogueManagerEmpl.container')),
);
const ClientsEmpl = Loadable(
  lazy(() => import('../features/clients/employe/ClientsEmpl.container')),
);

/* *************************Fournisseur*****************************************************************/
const FBCmdList = Loadable(
  lazy(() => import('../features/commande-fournisseur/fournisseur/FBCmdList.container')),
);
const FBStockDiamantList = Loadable(
  lazy(() => import('../features/stock-diamant-fb/fournisseur/FBStockDiamantList.container')),
);
const FBMvmStockDiaList = Loadable(
  lazy(() => import('../features/stock-diamant-fb/fournisseur/FBMvmStockDiaList.container')),
);
const FBMvmStockDiaDetails = Loadable(
  lazy(() => import('../features/stock-diamant-fb/fournisseur/FBMvmStockDiaDetails.container')),
);
const FBCatalogueList = Loadable(
  lazy(() => import('../features/catalogue/fournisseur/CatalogueFbList.container')),
);
/* ****Routes***** */

const Router = [
  {
    path: '/',
    element: <Navigate to="/auth" />,
  },
  {
    path: '/app',
    element: <PrivateRoute />,
    children: [
      { path: '', element: <Navigate to="home" /> },
      { path: 'home', exact: true, element: <TacheAdmReview /> },
      { path: 'users', exact: true, element: <Users /> },
      { path: 'clients', exact: true, element: <Clients /> },
      { path: 'fournisseurs', exact: true, element: <Fournisseurs /> },
      { path: 'groupe-magasins', exact: true, element: <GroupeMagasins /> },
      { path: 'magasins', exact: true, element: <Magasins /> },
      { path: 'security/rules', exact: true, element: <SecurityRule /> },
      { path: 'security/confid', exact: true, element: <SecurityDataAccess /> },
      { path: 'catalogues', exact: true, element: <Catalogues /> },
      { path: 'catalogues/pierres', exact: true, element: <CatalogueDiamants /> },
      { path: 'catalogues/settings', exact: true, element: <CatalogueSettings /> },
      { path: 'catalogues/cours-metaux', exact: true, element: <MetauxCoursManager /> },
      { path: 'achat/new', exact: true, element: <CmdFournisseurCEF /> },
      { path: 'achat', exact: true, element: <CmdFournisseurList /> },
      { path: 'achat/alerts', exact: true, element: <CmdFournisseurAlerts /> },
      { path: 'expedition', exact: true, element: <CmdExpeditionListContainer /> },
      { path: 'achat/edit-en-lot', exact: true, element: <CmdBulkEditContainer /> },
      { path: 'achat/reception', exact: true, element: <CmdBulkEditContainer pickup_mode={true} /> },
      { path: 'achat/archive', exact: true, element: <CmdArchiveList /> },
      { path: 'arrivage', exact: true, element: <CmdFournisseurArrivage /> },
      { path: 'arrivage/revoir/:id', exact: true, element: <CmdFournisseurRevoirArrivage /> },
      { path: 'arrivage/:id', exact: true, element: <ArrivageFbDetails /> },
      { path: 'dmd-reassort', exact: true, element: <DmdReassortList /> },
      { path: 'stock-diamant', exact: true, element: <StockDiamantManager /> },
      {
        path: 'stock-diamant/inventaire/create',
        exact: true,
        element: <InventaireDiamantDetailsContainer />,
      },
      {
        path: 'stock-diamant/inventaire/details/:id',
        exact: true,
        element: <InventaireDiamantDetailsContainer />,
      },
      {
        path: 'stock-diamant/inventaire',
        exact: true,
        element: <InventaireDiamantListContainer />,
      },
      { path: 'stock-diamant/inventaire2', exact: true, element: <StockDiamantInventaire /> },
      { path: 'stock-diamant/doc/create', exact: true, element: <DocumentDiamantFBCEF /> },
      { path: 'stock-diamant/doc/retour/create', exact: true, element: <RetourDiamantFBCEF /> },
      { path: 'stock-diamant/doc/sortie/create', exact: true, element: <SortieDiamantFBCEF /> },
      {
        path: 'stock-diamant/doc/saisie-forcee',
        exact: true,
        element: <SaisieStockDiamantForce />,
      },
      { path: 'stock-diamant/doc', exact: true, element: <DocumentDiamantFBList /> },
      { path: 'stock-diamant/doc/details/:id', exact: true, element: <DocumentDiamantFBDetails /> },
      { path: 'stock-diamant/stock-tampon', exact: true, element: <CDStockTmpAlertContainer /> },
      { path: 'stock-diamant-fb', exact: true, element: <StockDiamantFbList /> },
      { path: 'stock-diamant-fb/mvm', exact: true, element: <MvmStockDiaFbList /> },
      { path: 'stock-diamant-fb/mvm/create', exact: true, element: <MvmStockDiaFbCEF /> },
      { path: 'stock-diamant-fb/mvm/retour', exact: true, element: <RetourStockDiaFbCEF /> },
      { path: 'stock-diamant-fb/mvm/details/:id', exact: true, element: <MvmStockDiaFbDetails /> },
      { path: 'caisse', exact: true, element: <CaisseMenu /> },
      { path: 'caisse/doc-client', exact: true, element: <DocClientForm /> },
      { path: 'caisse/doc-client/list', exact: true, element: <DocClientList /> },
      { path: 'caisse/doc-client/:id', exact: true, element: <DocClientDetails /> },
      { path: 'caisse/acompte/list', exact: true, element: <AcompteClientList /> },
      { path: 'caisse/devis/list', exact: true, element: <DevisClientList /> },

      { path: 'caisse/reparation', exact: true, element: <ReparationForm /> },
      { path: 'caisse/reparation/doc/:id', exact: true, element: <ReparationForm /> },
      { path: 'caisse/reparation/list', exact: true, element: <ReparationList /> },
      { path: 'caisse/reparation/:id', exact: true, element: <ReparationDetails /> },
      { path: 'caisse/stripe', exact: true, element: <StripeClientList /> },
      { path: 'caisse/alma', exact: true, element: <AlmaClientList /> },
      { path: 'rdv', exact: true, element: <AdminCalendar /> },
      { path: 'tache', exact: true, element: <TacheListContainer /> },

      { path: 'vp', exact: true, element: <VentePrivee /> },
      { path: 'vp/:idVp', exact: true, element: <ProspectList /> },
      { path: 'vp/:idVp/planing', exact: true, element: <VpCalendar /> },
      { path: 'vp/:idVp/cs', exact: true, element: <VpCompagneSource /> },
      { path: 'vp/scan', exact: true, element: <VpProspectScannerContainer /> },
      { path: 'wsp', exact: true, element: <WhatsAppContainer /> },

      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="404" /> },
    ],
  },

  {
    path: '/app-frn',
    element: <PrivateRouteFrn />,
    children: [
      { path: '', element: <Navigate to="home" /> },
      { path: 'home', exact: true, element: <FBCmdList /> },
      { path: 'catalogue', exact: true, element: <FBCatalogueList /> },
      { path: 'commande', exact: true, element: <FBCmdList /> },
      { path: 'stock-diamant-fb', exact: true, element: <FBStockDiamantList /> },
      { path: 'mvm', exact: true, element: <FBMvmStockDiaList /> },
      { path: 'mvm/details/:id', exact: true, element: <FBMvmStockDiaDetails /> },
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="404" /> },
    ],
  },
  {
    path: '/app-empl',
    element: <PrivateRouteEmployee />,
    children: [
      { path: '', element: <Navigate to="home" /> },
      {
        path: 'home',
        exact: true,
        element: (
          <>
            <h1>Espace Emplyee</h1>
          </>
        ),
      },
      { path: 'catalogues', exact: true, element: <CataloguesEmpl /> },
      { path: 'clients', exact: true, element: <ClientsEmpl /> },
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="404" /> },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '', element: <Login /> },
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
